<template>
  <div v-loading="loading">
    <el-table
      class="proform-customer-order-table"
      v-if="tableConfig"
      :key="tableKey"
      :data="proformCustomerOrders.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/sales/proform-customer-orders/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="proformCustomerOrder"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :proform-customer-order="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="proformCustomerOrders.per_page"
        layout="total, prev, pager, next"
        :total="proformCustomerOrders.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    proformCustomerOrders() {
      return this.$store.getters['proformCustomerOrder/proformCustomerOrders'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['proformCustomerOrder/tableConfig']));
    },
    loading() {
      return this.$store.getters['proformCustomerOrder/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('proformCustomerOrder/setFilterString', '');
    this.$store.commit('proformCustomerOrder/setCurrentPage', this.currentPage);
    this.$store.commit('proformCustomerOrder/setSorting', this.currentSort);
    await this.$store.dispatch('proformCustomerOrder/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('proformCustomerOrder/setCurrentPage', val);
      this.$store.dispatch('proformCustomerOrder/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('proformCustomerOrder/setSorting', { prop, order, compareType: compareTypes[prop] || 'string' });
        this.$store.dispatch('proformCustomerOrder/fetchAll');
      }
    },
  },
};
</script>
<style lang="scss">
  .pointer-row {
    cursor: pointer;
  }
  /*.proform-customer-order-table {*/
  /*  .el-table__fixed-right{*/
  /*    width: 65px !important;*/
  /*    transition: width 1s;*/
  /*  }*/

  /*  .el-table__fixed-right:hover {*/
  /*    width: 260px !important;*/
  /*  }*/
  /*}*/

</style>

